import { memo } from "react";

import Control from "../FieldEditor/FieldEditor";
import ControlForm from "../FieldEditor/ControlForm";
import Label from "./Label";
import LabelForm from "./LabelForm";
import { useEditor } from "../EditorContext"
import ConfirmationModal from "../../../common/ConfirmationModal";


// чтобы заработала мемоизация нужно, чтобы при каждом обновлении формы не менялись пропсы и контекст у всех лейаутов
const HorizontalLayout = memo(function HorizontalLayout ({groupId, layout, formStructure}) {

  const {editingElement, removeElement, createLayout, createField, createLabel} = useEditor()
  let editingField = undefined

  let rows = [];
  for (let i in layout.elements) {

    let editingMark = undefined
    let controlClassName = "card p-0 h-layout-element" 
    if (layout.elements[i].id === editingElement) {
      editingField = layout.elements[i]
      controlClassName = "card p-0 h-layout-element editing-field"
      editingMark = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="rgb(136, 184, 255)" className="bi bi-caret-up-fill" viewBox="0 0 16 16">
                      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                    </svg>      
    }


    if (layout.elements[i].type === 'Control') {
      rows.push(
        <div key={layout.elements[i].id} className='col'>
          <div className={controlClassName}>
            <Control 
              control={layout.elements[i]}
              formStructure={formStructure}
              //removeElement={removeElement}
            />
          </div>
          {editingMark ? <div style={{position: 'relative', top: '0px', left: '0px'}}>{editingMark}</div> : <></>}
        </div>
      );
    }
    
    if (layout.elements[i].type === 'Label') {
      rows.push(
        <div key={layout.elements[i].id} className='col'>
          <div className={controlClassName}>
            <Label
              label={layout.elements[i]}
              formStructure={formStructure}
              //removeElement={removeElement}
            />
          </div>
          {editingMark ? <div style={{position: 'relative', top: '0px'}}>{editingMark}</div> : <></>}
        </div>
      );
    }
    
  }

  let modalId = 'confirmLayoutDeleteModal_' + layout.id

  return (
    <>

      <ConfirmationModal
        modalId={modalId}
        headerText="Горизонтальный макет"
        messageText={[
          "Вы уверены, что хотите удалить макет?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => removeElement(formStructure, layout.id)}
        danger
      />

      <fieldset className="border p-4 mt-3">
        <legend  className="float-none w-auto px-2 text-secondary fs-6">

          {/* 
          <button 
              className="btn editor-button mx-0 mt-2" 
              onClick={() => createLayout(formStructure, groupId, layout.id)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
          </button>
          <button 
              className="btn editor-button ms-1 me-0 mt-2" 
              onClick={() => createLabel(formStructure, groupId, layout.id)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="green" className="bi bi-plus-square" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
          </button>
          <button
            className="btn editor-button ms-1 me-0 mt-2"
            onClick={() => removeElement(formStructure, layout.id)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="red" className="bi bi-x-square" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg>
          </button>

        */}



          <button className="btn editor-button ms-1 me-0 mt-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-menu-button-wide" viewBox="0 0 16 16">
              <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
              <path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
            </svg>
          </button>
          <ul className="dropdown-menu">
            <button 
              className="dropdown-item lk-menu-dropdown" 
              onClick={() => createLayout(formStructure, groupId, layout.id)}
            >
              Добавить горизонтальный макет
            </button>
            <button className="dropdown-item lk-menu-dropdown" disabled>добавить вертикальный макет</button>
            <button 
              className="dropdown-item lk-menu-dropdown"
              onClick={() => createLabel(formStructure, groupId, layout.id)}
            >
              Добавить текст
            </button>
            <div className="dropdown-divider"></div>
            <button className="dropdown-item lk-menu-dropdown" disabled>переместить вверх</button>
            <button className="dropdown-item lk-menu-dropdown" disabled>переместить вниз</button>
            <button className="dropdown-item lk-menu-dropdown" disabled>скопировать макет</button>
            <div className="dropdown-divider"></div>
            <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target={'#' + modalId}>удалить макет</button> {/* здесь также был добавлен уникальный Id в прошлом коммите */}
          </ul>


          <span className="ms-2">Горизонтальный макет</span>
        </legend>
          <div className="row row-cols-6">
            {rows}
            {rows.length < 6 ?
              <>
                <div>
                  <div className="row">
                    <div>
                      <button 
                        className="btn editor-button m-0 me-1" 
                        onClick={() => createField(formStructure, groupId, layout.id)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 16 16">
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                        </svg>
                      </button>
                      <small>добавить поле</small>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div>
                      <button 
                        className="btn editor-button m-0 me-1" 
                        onClick={() => createLabel(formStructure, layout.id)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="rgb(47,82,160)" className="bi bi-plus-square" viewBox="0 0 16 16">
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                        </svg>
                      </button>
                      <small>добавить лейбл</small>
                    </div>
                  </div>  
                </div>
              </>  
            :
              <></>
            }
          </div>
          {editingField && editingField.type === 'Control' ?
            <ControlForm
              control={editingField}
              formStructure={formStructure}
            />
          : 
            <></>
          }

          {editingField && editingField.type === 'Label'?
            <LabelForm
              label={editingField}
              formStructure={formStructure}
              parentElementType='layout'
            />
          : 
            <></>
          }

      </fieldset>
    </>
  )
})

export default HorizontalLayout